import React, { useContext } from "react";
import { MiscContext } from "components/MiscProvider";

export default function useRating() {
  const { rating, setRating } = useContext(MiscContext);
  return { rating, setRating };
}
